/* ============================================================================
   PREDATOR page: the LPVO add-on (assets/predator-lpvo-1020.js). NEW FILE, 20 Oct 2026, dropdown pass the same day.
   Design: sourcing/PREDATOR-LPVO-1020/DESIGN.md plus Bon's dropdown brief (BRIEFS/predator-lpvo-dropdown-1020.md).
   Loaded (defer) by snippets/predator-lpvo-panel-1020.liquid (white buy box) and snippets/predator-lpvo-section-1020.liquid
   (dark LPVO PAIRING section). Edits NOTHING in predator-kit.js, pvs14-upsell.js, ngal-upsell.js or no-zoom-slider.*.

   ONE STORE: window.NOPredatorLPVO = { on, scope, mount, mountId, open } and the `no-lpvo:change` event (detail = get()).
     - WHITE BOX: a closed row by default (nothing in the cart). The row opens a dropdown: four scope tiles (tap again to
       take it off), a sideways carousel of every live 1.54 in mount for the picked tube (the black default picked, any
       other, or No mount), the CORE note, the sum, "See it through the scope".
     - DARK SECTION: the four cards pick the scope to LOOK THROUGH (the simulator under them). Their ADD TO KIT button is the
       separate buy action: it puts that scope in the kit, opens the white dropdown with it picked; pressing it again on
       the scope in the kit takes the LPVO out. A pick in the white box also moves the simulator to that scope.
     - SIMULATOR: built lazily. Each scope's simulator markup sits in a <template>; only the one being viewed is built,
       when the section is about 900 px from the screen. Scopes viewed before stay built and hidden (the simulator runs no
       animation loop while idle, so a hidden one costs nothing). The shared no-zoom-slider.js initialises every
       [data-zsim] it finds when it runs; it has no public init, so after adding a new one we run the same cached file
       again (it skips the ones already set up). Nothing in no-zoom-slider.* is changed.

   HOOK CONTRACT with predator-kit.js (window.NOPredatorKit), the same one ngal-upsell.js and pvs14-upsell.js use:
     1. CART LINES. predator-kit.js fires `no-predator:adding` with detail = the payload object, synchronously, BEFORE it
        stringifies it for the one /cart/add.js call. While the LPVO is on, this pushes {id: scope variant} and, while a
        mount is picked, {id: mount variant} onto detail.items: the SAME single request, the drawer opens as before.
     2. MONEY ON TOP. This module writes the kit total LAST (a microtask after every kit emit and every `no-pvs14:change`
        / `no-ngal:change`), so its figure (kit + PVS-14 + NGAL + LPVO + mount) is the one that stands.

   PRICES AND STOCK ARE NEVER TYPED HERE. The Liquid prints each product's variants; the live /products/<handle>.js is
   read again once the shopper starts using the LPVO. Sold out = never pickable. Variants are chosen by name, never by a
   fixed id. No em or en dashes.
   ========================================================================== */
(function () {
  'use strict';
  if (window.NOPredatorLPVO) return;

  var ORDER = ['vd16', 'rzg2', 'rz110', 'vd110'];
  var SCOPES = {
    vd16:  { handle: 'vd-1-6-lpvo', name: 'VD 1-6', tube: 30 },
    rzg2:  { handle: 'rz-1-6-lpvo-riflescope', name: 'RZ 1-6', tube: 30, prefer: ['tan', 'black'] },
    rz110: { handle: 'rz-1-10-lpvo', name: 'RZ 1-10', tube: 34 },
    vd110: { handle: 'vd-1-10-lpvo', name: 'VD 1-10', tube: 34 }
  };
  /* the default mount per tube (black, 1.54 in; Bon's 145A) */
  var DEF_MOUNT = { 30: 'geissele-super-precision-30mm-mount-1-54-and-1-93', 34: 'badger-c1-modular-scope-mount-34mm' };
  var DEFAULT_VIEW = 'rz110';   // the scope in Bon's own PREDATOR rifle photos

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function r2(n) { return Math.round(n * 100) / 100; }
  function cents(v) { var p = Number(v); return p ? p / 100 : 0; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(n) {
    var k = window.NOPredatorKit;
    if (k && typeof k.fmt === 'function') return k.fmt(n);
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function fmtWhole(n) {
    var k = window.NOPredatorKit;
    if (k && typeof k.fmtWhole === 'function') return k.fmtWhole(n);
    return '$' + Math.round(n).toLocaleString('en-US');
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  /* ---------------------------------------------------------------- live product data */
  var products = {};                 // handle -> [variants]
  var scopeV = {};                   // key -> chosen variant or null
  var mounts = { 30: [], 34: [] };   // tube -> [{ handle, name, img, colours: [variant] }] (1.54 in only, no plates)
  var mountById = {};                // variant id -> { v, m, tube }
  function vNorm(v) {
    var title = String(v.title || v.public_title || '');
    return { id: Number(v.id), title: title, price: cents(v.price), compare: cents(v.compare_at_price), available: !!v.available,
      img: v.img || (v.featured_image && (v.featured_image.src || v.featured_image)) || null,
      opts: [v.option1, v.option2, v.option3].filter(Boolean).map(function (o) { return String(o).toLowerCase(); }) };
  }
  function pickScopeVariant(key) {
    var vs = products[SCOPES[key].handle]; if (!vs || !vs.length) return null;
    var prefer = SCOPES[key].prefer || [];
    for (var i = 0; i < prefer.length; i++) {
      for (var j = 0; j < vs.length; j++) { if (vs[j].available && vs[j].opts.indexOf(prefer[i]) >= 0) return vs[j]; }
    }
    for (var k = 0; k < vs.length; k++) { if (vs[k].available) return vs[k]; }
    return null;
  }
  /* a mount variant fits when it is the 1.54 in height (or the product is 1.54 in only) with no extra plate or level */
  function colourOf(t) {
    t = t.toLowerCase();
    if (/\bfde\b/.test(t)) return 'FDE';
    if (/tan/.test(t)) return 'Tan';
    if (/black|\bbk\b/.test(t)) return 'Black';
    return '';
  }
  var mountMeta = {};                // handle -> { title, img } from the printed list
  function buildMounts() {
    mountById = {};
    [30, 34].forEach(function (tube) {
      mounts[tube] = (mounts[tube + 'h'] || []).map(function (h) {
        var meta = mountMeta[h] || {}, vs = products[h] || [];
        /* a product sold at 1.54 in only (its title says 1.54 and no other height) fits whatever its variants are called */
        var t0 = String(meta.title || ''), single = vs.length === 1 || (t0.indexOf('1.54') >= 0 && !/1\.70|1\.93|1\.50/.test(t0));
        var name = String(meta.title || h).split(' | ')[0].replace(/\s+/g, ' ').trim();
        var fits = vs.filter(function (v) {
          var t = v.title.toLowerCase();
          if (/plate|bubble|level|1\.70|1\.93/.test(t)) return false;
          return single || t.indexOf('1.54') >= 0;
        });
        var m = { handle: h, name: name, img: meta.img || null, colours: fits };
        fits.forEach(function (v) { v.colour = colourOf(v.title); mountById[v.id] = { v: v, m: m, tube: tube }; });
        return m;
      }).filter(function (m) { return m.colours.length; });
      /* the default black mount first, then by price */
      mounts[tube].sort(function (a, b) {
        if (a.handle === DEF_MOUNT[tube]) return -1; if (b.handle === DEF_MOUNT[tube]) return 1;
        return lowPrice(a) - lowPrice(b);
      });
    });
  }
  function lowPrice(m) { var lo = 0; m.colours.forEach(function (v) { if (v.available && (!lo || v.price < lo)) lo = v.price; }); return lo || 1e9; }
  function firstAvail(m, colour) {
    var i;
    if (colour) for (i = 0; i < m.colours.length; i++) if (m.colours[i].available && m.colours[i].colour === colour) return m.colours[i];
    for (i = 0; i < m.colours.length; i++) if (m.colours[i].available && m.colours[i].colour === 'Black') return m.colours[i];
    for (i = 0; i < m.colours.length; i++) if (m.colours[i].available) return m.colours[i];
    return null;
  }
  function defaultMount(tube) {
    var list = mounts[tube] || [];
    for (var i = 0; i < list.length; i++) { var v = firstAvail(list[i], 'Black'); if (v) return v; }
    return null;
  }
  function resolve() {
    buildMounts();
    ORDER.forEach(function (k) { scopeV[k] = pickScopeVariant(k); });
    [30, 34].forEach(function (t) {
      var cur = state.mountSel[t] && mountById[state.mountSel[t]];
      if (!cur || !cur.v.available) { var d = defaultMount(t); state.mountSel[t] = d ? d.id : null; }
    });
  }
  function anyScope() { return ORDER.some(function (k) { return !!scopeV[k]; }); }
  function readPrinted() {
    $$('script[data-lpvo-data]').forEach(function (el) {
      try { var d = JSON.parse(el.textContent); Object.keys(d).forEach(function (h) { if (d[h] && d[h].length) products[h] = d[h].map(vNorm); }); } catch (e) {}
    });
    var md = $('script[data-lpvo-mounts-data]');
    if (md) {
      try {
        var m = JSON.parse(md.textContent);
        [30, 34].forEach(function (t) {
          mounts[t + 'h'] = (m[t] || []).map(function (p) {
            mountMeta[p.handle] = { title: p.title, img: p.img };
            if (p.variants && p.variants.length) products[p.handle] = p.variants.map(vNorm);
            return p.handle;
          });
        });
      } catch (e) {}
    }
    if (!mounts['30h']) { mounts['30h'] = [DEF_MOUNT[30]]; mounts['34h'] = [DEF_MOUNT[34]]; }
  }
  function readLive() {
    var hs = ORDER.map(function (k) { return SCOPES[k].handle; }).concat(mounts['30h'], mounts['34h']);
    /* one after another, never a burst (the store answers 429 to six at once) */
    return hs.reduce(function (chain, h) {
      return chain.then(function () {
        return fetch(root() + 'products/' + h + '.js', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(h + ' ' + r.status); return r.json(); })
          .then(function (p) {
            if (!p || !p.variants || !p.variants.length) return;
            var old = {}; (products[h] || []).forEach(function (v) { old[v.id] = v; });
            products[h] = p.variants.map(function (v) {
              var n = vNorm(v); if (old[n.id] && old[n.id].img) n.img = old[n.id].img;   /* keep the small printed picture */
              return n;
            });
            if (mountMeta[h] && p.title) mountMeta[h].title = p.title;
          })
          .catch(function () { /* keep the printed data for this one */ });
      });
    }, Promise.resolve());
  }

  /* ---------------------------------------------------------------- state */
  var state = { on: false, scope: null, mount: true, mountSel: { 30: null, 34: null }, open: false };
  var view = DEFAULT_VIEW;
  var subs = [];
  function tubeOf(key) { return SCOPES[key] ? SCOPES[key].tube : 34; }
  function cur() { return state.on && state.scope ? scopeV[state.scope] : null; }
  function mountFor(tube) { var x = state.mountSel[tube] && mountById[state.mountSel[tube]]; return x && x.v.available ? x : null; }
  function curMount() { if (!cur() || !state.mount) return null; var x = mountFor(tubeOf(state.scope)); return x ? x.v : null; }
  function get() {
    var s = cur(), m = curMount(), mx = m ? mountById[m.id] : null;
    return {
      on: !!s, scope: state.scope, name: state.scope ? SCOPES[state.scope].name : '', mount: !!m,
      scopeId: s ? s.id : null, mountId: m ? m.id : null, mountName: mx ? mx.m.name + (m.colour ? ', ' + m.colour : '') : '',
      price: r2((s ? s.price : 0) + (m ? m.price : 0)), compare: r2((s ? (s.compare || s.price) : 0) + (m ? (m.compare || m.price) : 0)),
      view: view, open: state.open
    };
  }
  function emit() {
    var s = get();
    for (var i = 0; i < subs.length; i++) { try { subs[i](s); } catch (e) { if (window.console) console.error('[no-lpvo] subscriber', e); } }
    try { document.dispatchEvent(new CustomEvent('no-lpvo:change', { detail: s })); } catch (e) {}
  }
  function firstAvailable() {
    if (scopeV[DEFAULT_VIEW]) return DEFAULT_VIEW;
    for (var i = 0; i < ORDER.length; i++) { if (scopeV[ORDER[i]]) return ORDER[i]; }
    return null;
  }
  /* set(true) = the old "tick": open and pick the default scope; set(false) = take the LPVO out */
  function setOn(on) {
    if (on) { var k = state.scope && scopeV[state.scope] ? state.scope : firstAvailable(); if (k) { pick(k); return; } }
    state.on = false; emit();
  }
  function pick(key) {
    if (!SCOPES[key] || !scopeV[key]) return;
    state.scope = key; state.on = true; state.open = true;
    setView(key);
    emit();
  }
  function unpick() { state.on = false; emit(); }
  function setMount(on) { on = !!on; if (state.mount === on) return; state.mount = on; emit(); }
  function pickMount(id) {
    var x = mountById[id]; if (!x || !x.v.available) return;
    state.mountSel[x.tube] = x.v.id; state.mount = true; emit();
  }
  function setOpen(o) { o = !!o; if (state.open === o) return; state.open = o; emit(); }

  var api = window.NOPredatorLPVO = {
    get: get, set: setOn, pick: pick, unpick: unpick, setMount: setMount, pickMount: pickMount, open: setOpen,
    view: function (k) { setView(k); emit(); },
    mounts: function (tube) { return (mounts[tube] || []).map(function (m) { return { handle: m.handle, name: m.name, colours: m.colours.map(function (v) { return { id: v.id, colour: v.colour, price: v.price, available: v.available }; }) }; }); },
    items: function () { var s = get(), out = []; if (s.on) { out.push({ id: s.scopeId, quantity: 1 }); if (s.mountId) out.push({ id: s.mountId, quantity: 1 }); } return out; },
    subscribe: function (fn) { subs.push(fn); fn(get()); return function () { var i = subs.indexOf(fn); if (i >= 0) subs.splice(i, 1); }; }
  };

  /* ---------------------------------------------------------------- HOOK 1: the cart lines */
  document.addEventListener('no-predator:adding', function (ev) {
    var p = ev && ev.detail;
    if (!p || !p.items || typeof p.items.push !== 'function') return;
    api.items().forEach(function (line) {
      if (!line.id) return;
      for (var i = 0; i < p.items.length; i++) { if (Number(p.items[i].id) === Number(line.id)) return; }
      p.items.push(line);
    });
  });

  /* ---------------------------------------------------------------- the simulator: lazy, one scope at a time */
  var simsBox = null, simsLive = false, simMade = {}, cssP = null;
  function loadCss() {
    if (cssP) return cssP;
    var href = simsBox && simsBox.getAttribute('data-zs-css');
    cssP = new Promise(function (res) {
      var have = $$('link[rel="stylesheet"]').filter(function (l) { return href && l.href && l.href.split('?')[0] === new URL(href, location.href).href.split('?')[0]; })[0];
      if (have && have.sheet) return res();
      if (!href) return res();
      var l = have || document.createElement('link');
      l.addEventListener('load', function () { res(); }); l.addEventListener('error', function () { res(); });
      if (!have) { l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l); }
      setTimeout(res, 4000);
    });
    return cssP;
  }
  function runSimJs() {
    var src = simsBox && simsBox.getAttribute('data-zs-js');
    return new Promise(function (res) {
      if (!src) return res();
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { res(); }; s.onerror = function () { res(); };
      document.body.appendChild(s);
    });
  }
  function makeSim(key) {
    if (simMade[key]) return simMade[key];
    var w = $('[data-lpvo-sim="' + key + '"]', simsBox), tpl = $('template[data-lpvo-simtpl="' + key + '"]', simsBox);
    if (!w || !tpl) return Promise.resolve();
    var frag = tpl.content.cloneNode(true);
    $$('link, script', frag).forEach(function (n) { n.parentNode.removeChild(n); });   /* the files are loaded once, below */
    simMade[key] = loadCss().then(function () {
      w.appendChild(frag);
      w.hidden = key !== view;
      simsBox.removeAttribute('data-lpvo-pending');
      return runSimJs();
    });
    return simMade[key];
  }
  function showSim(key) {
    if (!simsBox || !simsLive) return;
    var fresh = !simMade[key];
    makeSim(key).then(function () {
      if (key !== view) return;
      $$('[data-lpvo-sim]', simsBox).forEach(function (w) {
        var show = w.getAttribute('data-lpvo-sim') === key, was = !w.hidden;
        w.hidden = !show;
        if (show && (!was || fresh)) {
          /* each scope starts at its own lowest power when it comes into view */
          var el = $('[data-zsim]', w);
          requestAnimationFrame(function () { requestAnimationFrame(function () {
            try { if (el && el.__zs && !fresh) el.__zs.set(el.__zs.min); } catch (e) {}
            try { window.dispatchEvent(new Event('resize')); } catch (e) {}
          }); });
        }
      });
    });
  }
  function bindSims() {
    simsBox = $('[data-lpvo-sims]'); if (!simsBox) return;
    function go() { if (simsLive) return; simsLive = true; showSim(view); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '900px 0px' });
      io.observe(simsBox);
    } else go();
  }
  function setView(key) {
    if (!SCOPES[key]) return;
    view = key;
    $$('[data-lpvo-view]').forEach(function (b) {
      var on = b.getAttribute('data-lpvo-view') === key;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var c = b.closest('[data-lpvo-card]'); if (c) c.classList.toggle('is-view', on);
    });
    showSim(key);
  }

  /* ---------------------------------------------------------------- DOM: white panel (the dropdown) */
  function placePanel() {
    var panel = document.getElementById('no-lpvo-panel'); if (!panel) return null;
    var kit = document.getElementById('no-predator-kit');
    var box = kit && $('[data-no-pk-helmet]', kit);
    if (kit && (!box || box.hidden) && panel.closest('[data-no-pk-helmet]')) {
      /* the helmet box hid itself for this visitor: stand on our own with our own heading */
      var sum = $('.no-pk__summary', kit);
      if (sum && sum.parentNode) sum.parentNode.insertBefore(panel, sum);
      var own = $('[data-lpvo-own-title]', panel); if (own) own.hidden = false;
    }
    return panel;
  }
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  function bindPanel(panel) {
    if (!panel || panel.hasAttribute('data-lpvo-bound')) return;
    panel.setAttribute('data-lpvo-bound', '1');
    var head = $('[data-lpvo-head]', panel), sub = $('[data-lpvo-sub]', panel), headSub = $('[data-lpvo-head-sub]', panel);
    var picks = $$('[data-lpvo-pick]', panel), tiles = $$('[data-lpvo-tile]', panel);
    var from = $('[data-lpvo-from]', panel), tier = $('[data-lpvo-tier]', panel), flipBtn = $('[data-lpvo-addflip]', panel);
    var math = $('[data-lpvo-math]', panel), mathLabel = $('[data-lpvo-math-label]', panel), see = $('[data-lpvo-see]', panel);
    var mBox = $('[data-lpvo-mounts]', panel), track = $('[data-lpvo-track]', panel), mEmpty = $('[data-lpvo-mounts-empty]', panel);
    var mTitle = $('[data-lpvo-mounts-title]', panel), arrows = $$('[data-lpvo-arrow]', panel);
    var headSubDefault = headSub ? headSub.textContent : '';

    if (head) head.addEventListener('click', function () { setOpen(!state.open); });
    picks.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-lpvo-pick');
        if (state.on && state.scope === k) unpick(); else pick(k);
      });
    });
    if (flipBtn) flipBtn.addEventListener('click', function (e) { e.preventDefault(); var k = window.NOPredatorKit; if (k) k.set('flip', true); });
    if (see) see.addEventListener('click', function (e) {
      var sec = document.getElementById('lpvo'); if (!sec) return;
      e.preventDefault(); if (state.on) setView(state.scope); emit();
      var target = $('.no-lp-hint', sec) || sec;
      var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function topOf() { return target.getBoundingClientRect().top + window.pageYOffset - 90; }
      window.scrollTo({ top: topOf(), behavior: rm ? 'auto' : 'smooth' });
      /* pictures above it may still be loading and push it down: land it again once the glide is over */
      setTimeout(function () { var y = topOf(); if (Math.abs(window.pageYOffset - y) > 40) window.scrollTo({ top: y, behavior: 'auto' }); }, 1100);
    });

    /* the mount carousel: built per tube, then only its pick state is repainted */
    var builtTube = null, builtSig = '';
    function card(m) {
      var v0 = firstAvail(m), any = !!v0;
      var pills = m.colours.length > 1 ? '<span class="no-lp-mc__cols" role="group" aria-label="Colour">' + m.colours.map(function (v) {
        return '<button type="button" class="no-lp-mc__col" data-lpvo-mcol="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-pressed="false">' + esc(v.colour || v.title) + '</button>';
      }).join('') + '</span>' : (m.colours[0].colour ? '<span class="no-lp-mc__one">' + esc(m.colours[0].colour) + '</span>' : '');
      var img = (v0 && v0.img) || m.img;
      return '<div class="no-lp-mc' + (any ? '' : ' is-soldout') + '" data-lpvo-mcard="' + esc(m.handle) + '">' +
        '<button type="button" class="no-lp-mc__main" data-lpvo-mpick="' + (v0 ? v0.id : '') + '" aria-pressed="false"' + (any ? '' : ' disabled') + '>' +
          '<span class="no-lp-mc__chip" aria-hidden="true">' + CHECK + 'PICKED</span>' +
          '<span class="no-lp-mc__pic">' + (img ? '<img src="' + esc(img) + '" alt="" width="240" height="240" loading="lazy" decoding="async">' : '') + '</span>' +
          '<span class="no-lp-mc__name">' + esc(m.name) + '</span>' +
          '<span class="no-lp-mc__spec">' + (builtTube) + ' mm tube, 1.54 in</span>' +
          '<span class="no-lp-mc__money"><b data-lpvo-mprice>' + (v0 ? fmt(v0.price) : 'Sold out') + '</b>' + (v0 && v0.compare > v0.price ? ' <s>' + fmt(v0.compare) + '</s>' : '') + '</span>' +
        '</button>' + pills + '</div>';
    }
    function buildTrack(tube) {
      var list = mounts[tube] || [];
      var sig = tube + ':' + list.map(function (m) { return m.handle + m.colours.map(function (v) { return v.id + (v.available ? 'y' : 'n') + v.price; }).join(','); }).join('|');
      if (sig === builtSig) return;
      builtSig = sig; builtTube = tube;
      track.innerHTML = list.map(card).join('') +
        '<div class="no-lp-mc no-lp-mc--none" data-lpvo-mcard="none"><button type="button" class="no-lp-mc__main" data-lpvo-mnone aria-pressed="false">' +
        '<span class="no-lp-mc__chip" aria-hidden="true">' + CHECK + 'PICKED</span>' +
        '<span class="no-lp-mc__pic no-lp-mc__pic--none" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="m5.7 5.7 12.6 12.6"/></svg></span>' +
        '<span class="no-lp-mc__name">No mount</span><span class="no-lp-mc__spec">I already have a 1.54 in mount</span><span class="no-lp-mc__money"><b>$0.00</b></span></button></div>';
      track.scrollLeft = 0;
    }
    if (track) {
      track.addEventListener('click', function (e) {
        var t = e.target;
        var col = t.closest('[data-lpvo-mcol]'); if (col) { pickMount(Number(col.getAttribute('data-lpvo-mcol'))); return; }
        var mp = t.closest('[data-lpvo-mpick]');
        if (mp) {
          var c = mp.closest('[data-lpvo-mcard]'), h = c && c.getAttribute('data-lpvo-mcard');
          /* keep the colour already chosen on this card, else black */
          var curV = curMount(), m = null;
          (mounts[builtTube] || []).forEach(function (x) { if (x.handle === h) m = x; });
          if (!m) return;
          var keep = curV && mountById[curV.id] && mountById[curV.id].m === m ? curV : null;
          if (keep && state.mount) { return; }
          var sel = state.mountSel[builtTube] && mountById[state.mountSel[builtTube]];
          var v = sel && sel.m === m ? sel.v : firstAvail(m, 'Black');
          if (v) pickMount(v.id);
          return;
        }
        if (t.closest('[data-lpvo-mnone]')) setMount(false);
      });
      track.addEventListener('scroll', function () { arrowState(); }, { passive: true });
    }
    function arrowState() {
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      arrows.forEach(function (a) { var d = +a.getAttribute('data-lpvo-arrow'); a.disabled = d < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max; });
    }
    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        var c = $('.no-lp-mc', track), step = c ? c.getBoundingClientRect().width + 10 : 160;
        track.scrollBy({ left: +a.getAttribute('data-lpvo-arrow') * step * Math.max(1, Math.floor(track.clientWidth / step) - 0), behavior: 'smooth' });
      });
    });
    function revealPicked() {
      var el = $('.no-lp-mc.is-pick', track); if (!el) return;
      var l = el.offsetLeft - track.offsetLeft, r = l + el.offsetWidth;
      if (l < track.scrollLeft || r > track.scrollLeft + track.clientWidth) track.scrollLeft = Math.max(0, l - 8);
    }

    var lastScope = null, wasOpen = false;
    api.subscribe(function (s) {
      var kitS = window.NOPredatorKit ? window.NOPredatorKit.get() : null;
      if (!anyScope()) { panel.hidden = true; return; }
      panel.hidden = false;
      panel.classList.toggle('is-open', s.open); panel.classList.toggle('is-on', s.on);
      if (head) head.setAttribute('aria-expanded', s.open ? 'true' : 'false');
      if (sub) sub.hidden = !s.open;
      var lo = 0; ORDER.forEach(function (k) { var v = scopeV[k]; if (v && (!lo || v.price < lo)) lo = v.price; });
      if (from) from.textContent = s.on ? '+' + fmt(s.price) : 'from ' + fmt(lo);
      if (headSub) headSub.textContent = s.on ? 'In your kit: ' + s.name + (s.mount ? ' + ' + s.mountName : ', no mount') : headSubDefault;
      tiles.forEach(function (t) {
        var k = t.getAttribute('data-lpvo-tile');
        t.classList.toggle('is-pick', s.on && s.scope === k); t.classList.toggle('is-soldout', !scopeV[k]);
      });
      picks.forEach(function (b) {
        var k = b.getAttribute('data-lpvo-pick'), v = scopeV[k];
        b.disabled = !v; b.toggleAttribute('data-lpvo-soldout', !v);
        b.setAttribute('aria-pressed', s.on && s.scope === k ? 'true' : 'false');
        b.setAttribute('aria-label', SCOPES[k].name + (s.on && s.scope === k ? ', picked. Press again to take it off.' : ''));
        paintMoney(b, v);
      });
      /* mounts */
      if (mBox) {
        var has = s.on;
        mBox.classList.toggle('is-empty', !has);
        if (mEmpty) mEmpty.hidden = has;
        if (track) track.hidden = !has;
        arrows.forEach(function (a) { a.hidden = !has; });
        if (has) {
          var tube = tubeOf(s.scope);
          buildTrack(tube);
          if (mTitle) mTitle.textContent = '2. Pick a 1.54 in mount for the ' + tube + ' mm tube';
          var curId = s.mountId;
          $$('.no-lp-mc', track).forEach(function (c) {
            var h = c.getAttribute('data-lpvo-mcard'), on;
            if (h === 'none') on = !s.mount;
            else { var x = curId && mountById[curId]; on = !!(x && x.m.handle === h); }
            c.classList.toggle('is-pick', on);
            var main = $('.no-lp-mc__main', c); if (main) main.setAttribute('aria-pressed', on ? 'true' : 'false');
            /* the colour shown on each card: the picked one, or the one remembered for this tube, or black */
            var sel = state.mountSel[tube] && mountById[state.mountSel[tube]];
            $$('[data-lpvo-mcol]', c).forEach(function (p) {
              var id = Number(p.getAttribute('data-lpvo-mcol')), x2 = mountById[id];
              var shown = on ? id === curId : (sel && sel.m === (x2 && x2.m) ? id === sel.v.id : (x2 && firstAvail(x2.m, 'Black') && firstAvail(x2.m, 'Black').id === id));
              p.setAttribute('aria-pressed', shown ? 'true' : 'false');
              if (shown && x2) {
                var pm = $('[data-lpvo-mpick]', c); if (pm) pm.setAttribute('data-lpvo-mpick', id);
                var im = $('.no-lp-mc__pic img', c); if (im && x2.v.img && im.getAttribute('src') !== x2.v.img) im.setAttribute('src', x2.v.img);
                var pr = $('[data-lpvo-mprice]', c); if (pr) pr.textContent = fmt(x2.v.price);
              }
            });
          });
          if (s.scope !== lastScope || (s.open && !wasOpen)) requestAnimationFrame(function () { revealPicked(); arrowState(); });
          else arrowState();
        }
      }
      lastScope = s.on ? s.scope : null; wasOpen = s.open;
      if (mathLabel) mathLabel.textContent = s.mount ? 'LPVO + mount' : 'LPVO';
      if (math) math.textContent = s.on ? '+' + fmt(s.price) : '+' + fmt(0);
      var mathRow = math && math.parentNode; if (mathRow) mathRow.hidden = !s.on;
      if (tier) tier.hidden = !(s.on && kitS && kitS.tier === 'core' && !kitS.flip);
    });
  }
  function paintMoney(el, v) {
    var pe = $('[data-lpvo-price]', el), ce = $('[data-lpvo-compare]', el), co = $('[data-lpvo-colour]', el);
    if (pe) pe.textContent = v ? fmt(v.price) : 'Sold out';
    if (ce) { var show = v && v.compare > v.price; ce.hidden = !show; ce.textContent = show ? fmt(v.compare) : ''; }
    if (co) co.textContent = v && v.title && v.title !== 'Default Title' ? v.title : '';
  }

  /* ---------------------------------------------------------------- DOM: dark section */
  function bindSection() {
    var sec = document.getElementById('lpvo');
    if (!sec || sec.hasAttribute('data-lpvo-bound')) return;
    sec.setAttribute('data-lpvo-bound', '1');
    var cards = $$('[data-lpvo-card]', sec);
    cards.forEach(function (c) {
      var k = c.getAttribute('data-lpvo-card'), add = $('[data-lpvo-add]', c), mb = $('[data-lpvo-card-mount]', c), vb = $('[data-lpvo-view]', c);
      /* a tap on the card picks it for the simulator; the ADD TO KIT button, the mount box and the link do their own job */
      c.addEventListener('click', function (e) {
        if (e.target.closest('[data-lpvo-add], .no-lp-card__mount, .no-lp-card__link')) return;
        setView(k); emit();
      });
      if (add) add.addEventListener('click', function () {
        var s = get();
        if (s.on && s.scope === k) unpick(); else pick(k);
      });
      if (mb) mb.addEventListener('change', function () { setMount(mb.checked); });
      void vb;
    });
    var bar = $('[data-lpvo-bar]', sec), barName = $('[data-lpvo-bar-name]', sec), barTotal = $('[data-lpvo-bar-total]', sec);
    var barCompare = $('[data-lpvo-bar-compare]', sec), cta = $('[data-lpvo-bar-cta]', sec), ctaTxt = $('[data-lpvo-bar-cta-txt]', sec), err = $('[data-lpvo-bar-err]', sec);
    if (cta) cta.addEventListener('click', function (e) {
      e.preventDefault();
      var k = window.NOPredatorKit; if (!k || k.isLocked()) return;
      if (err) { err.hidden = true; err.textContent = ''; }
      k.addToCart(cta, function (ex) { if (ex && err) { err.textContent = String(ex.message || ex); err.hidden = false; } });
    });
    api.subscribe(function (s) {
      cards.forEach(function (c) {
        var k = c.getAttribute('data-lpvo-card'), v = scopeV[k], add = $('[data-lpvo-add]', c), mb = $('[data-lpvo-card-mount]', c);
        var picked = s.on && s.scope === k, mx = mountFor(tubeOf(k));
        c.classList.toggle('is-soldout', !v); c.classList.toggle('is-pick', picked);
        paintMoney(c, v);
        if (mb) { mb.checked = !!(state.mount && mx); mb.disabled = !mx; }
        if (add) {
          add.disabled = !v; add.classList.toggle('is-in', picked);
          var amt = v ? r2(v.price + (state.mount && mx ? mx.v.price : 0)) : 0;
          add.innerHTML = !v ? '<span>SOLD OUT</span>' : picked ? CHECK + '<span>IN YOUR KIT</span>' : '<span>ADD TO KIT</span> <span>+' + fmt(amt) + '</span>';
          add.setAttribute('aria-pressed', picked ? 'true' : 'false');
          add.setAttribute('aria-label', !v ? SCOPES[k].name + ' sold out' : picked ? SCOPES[k].name + ' is in your kit. Press to take it out.' : 'Add the ' + SCOPES[k].name + (state.mount && mx ? ' and its 1.54 in mount' : '') + ' to your kit');
        }
      });
      if (bar) bar.hidden = false;
    });
    renderBar = function (m) {
      if (barName) barName.textContent = m.name;
      if (barTotal) barTotal.textContent = fmt(m.total);
      if (barCompare) { barCompare.textContent = m.compare > m.total ? fmt(m.compare) : ''; }
      if (cta) {
        var k = window.NOPredatorKit, locked = k && k.isLocked();
        cta.disabled = !!locked;
        if (ctaTxt && !locked) ctaTxt.textContent = 'ADD TO CART';
      }
    };
    var k0 = window.NOPredatorKit;
    if (k0 && k0.onTick) k0.onTick(function (ms) { if (ctaTxt && ms > 0) ctaTxt.textContent = 'OPENS IN ' + k0.clock(ms); });
  }
  var renderBar = null;

  /* ---------------------------------------------------------------- the #buy order card at the bottom */
  var buyRows = null;
  function bindBuy() {
    var buy = document.getElementById('buy'); if (!buy || buyRows) return;
    var hint = $('[data-no="buy-hint"]', buy);
    if (!hint || !hint.parentNode) return;
    buyRows = document.createElement('div');
    buyRows.className = 'no-lp-buyrows'; buyRows.setAttribute('data-lpvo-buy', ''); buyRows.hidden = true;
    buyRows.innerHTML = '<div class="no-lp-buyrow"><span data-lpvo-buy-scope>LPVO</span><span data-lpvo-buy-sp></span></div>' +
      '<div class="no-lp-buyrow" data-lpvo-buy-mrow><span>1.54 IN MOUNT</span><span data-lpvo-buy-mp></span></div>';
    hint.parentNode.insertBefore(buyRows, hint);
  }

  /* ---------------------------------------------------------------- HOOK 2: money on top */
  var queued = false;
  function queue() { if (queued) return; queued = true; Promise.resolve().then(function () { queued = false; renderMoney(); }); }
  function addOnAmounts() {
    var a = 0, names = [];
    try { var p = window.NOPvs14Upsell && window.NOPvs14Upsell.get(); if (p && p.selected) { a += Number(p.price) || 0; names.push('PVS-14'); } } catch (e) {}
    try { var n = window.NONgalUpsell && window.NONgalUpsell.get(); if (n && n.selected) { a += Number(n.price) || 0; names.push('NGAL'); } } catch (e) {}
    return { amount: r2(a), names: names };
  }
  function renderMoney() {
    var kit = window.NOPredatorKit; if (!kit) return;
    var k = kit.get(), s = get(), o = addOnAmounts();
    var total = r2(k.price + o.amount + s.price), compare = r2(k.compare + o.amount + s.compare), save = r2(compare - total);
    var kitRoot = document.getElementById('no-predator-kit');
    if (kitRoot) {
      /* with the LPVO off this writes exactly what the kit and the PVS-14 / NGAL modules write */
      var t = $('[data-no-pk-total]', kitRoot), c = $('[data-no-pk-compare]', kitRoot), sv = $('[data-no-pk-save]', kitRoot), nm = $('[data-no-pk-name]', kitRoot);
      if (t) t.textContent = fmt(total);
      if (c) c.textContent = fmt(compare);
      if (sv) { sv.textContent = 'SAVE ' + fmtWhole(save); sv.hidden = save <= 0; }
      if (nm) nm.textContent = k.name + (k.helmet ? ' + HELMET' : '') + (s.on ? ' + LPVO' : '');
      var info = kitRoot.closest('.product__info-container') || kitRoot.closest('[id^="ProductInfo-"]') || document;
      var priceBox = $('[id^="price-"]', info);
      if (priceBox) {
        $$('.price__sale .price-item--sale, .price__regular .price-item--regular', priceBox).forEach(function (el) { el.textContent = fmt(total); });
        $$('.price__compare-price s, .price__compare-price .price-item--regular', priceBox).forEach(function (el) { el.textContent = fmt(compare); });
        $$('.price__badge-sale .nowrap', priceBox).forEach(function (el) { el.textContent = 'SAVE $' + Math.round(save).toLocaleString('en-US'); });
      }
    }
    bindBuy();
    $$('[data-no="buy-total"]').forEach(function (el) { el.textContent = fmt(total); });
    var sez = $('[data-no="buy-sezzle"]'); if (sez) sez.textContent = 'or 4 interest-free payments of $' + (total / 4).toFixed(2) + ' over 6 weeks with Sezzle';
    if (buyRows) {
      buyRows.hidden = !s.on;
      var sv2 = s.on ? scopeV[s.scope] : null, mv = curMount();
      $('[data-lpvo-buy-scope]', buyRows).textContent = 'LPVO: ' + s.name;
      $('[data-lpvo-buy-sp]', buyRows).textContent = sv2 ? fmt(sv2.price) : '';
      $('[data-lpvo-buy-mrow]', buyRows).hidden = !mv;
      $('[data-lpvo-buy-mp]', buyRows).textContent = mv ? fmt(mv.price) : '';
    }
    if (renderBar) {
      var parts = [k.name];
      if (k.helmet) parts.push('HELMET');
      o.names.forEach(function (x) { parts.push(x); });
      if (s.on) { parts.push(s.name); if (s.mount) parts.push('1.54 IN MOUNT'); }
      renderBar({ name: parts.join(' + '), total: total, compare: compare });
    }
  }

  function bindKit() {
    var kit = window.NOPredatorKit;
    if (!kit || typeof kit.subscribe !== 'function') return false;
    if (bindKit.done) return true;
    bindKit.done = true;
    kit.subscribe(function () { queue(); });
    api.subscribe(function () { queue(); });
    document.addEventListener('no-pvs14:change', queue);
    document.addEventListener('no-ngal:change', queue);
    kit.subscribe(function () { emitSoon(); });   /* the tier note follows the kit too */
    return true;
  }
  var soon = false;
  function emitSoon() { if (soon) return; soon = true; Promise.resolve().then(function () { soon = false; for (var i = 0; i < subs.length; i++) { try { subs[i](get()); } catch (e) {} } }); }

  function init() {
    readPrinted(); resolve();
    if (!scopeV[view]) { var f = firstAvailable(); if (f) view = f; }
    bindPanel(placePanel());
    bindSection();
    bindSims();
    setView(view);
    emit();
    if (!bindKit()) { var n = 0, t = setInterval(function () { if (bindKit() || ++n > 40) { clearInterval(t); queue(); } }, 250); }
    else queue();
    /* the page carries live variant data; the stock is read again only once the shopper opens or uses the LPVO, so a visit
       that never touches it costs the store no extra requests */
    var refreshed = false;
    api.subscribe(function (s) {
      if (refreshed || !(s.on || s.open)) return;
      refreshed = true;
      readLive().then(function () {
        resolve();
        if (state.on && !scopeV[state.scope]) state.on = false;
        emit();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
